// extracted by mini-css-extract-plugin
export default {"container":"aCDiva4yt6lk8hsUOs1e"};